//import config from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Image, Grid, AspectRatio } from '@mantine/core';
import { clear_newscreenshot } from "../../slice/mainslice";
import { Trash, Check } from 'tabler-icons-react';
import intl from "react-intl-universal";
import { useEffect, useState } from "react";




const ModalTakeScreen = (props:any) => {  
    const dispatch = useDispatch()
    const screenshots = useSelector((state: any) => state.user.identscreenshots)
    const newscreenshots = useSelector((state: any) => state.user.newscreenshot)
    const newscreenshotsuid = useSelector((state: any) => state.user.newscreenshotid)
    const token = useSelector((state: any) => state.user.token)
    const [openscreenident, setOpenscreenident] = useState(true);

    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

   // console.log(screenHeight)

    useEffect(() => {
      const handleResize = () => {
        setScreenHeight(window.innerHeight);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    useEffect(() => {
        if (newscreenshots && newscreenshotsuid === props.meetingParticipantId) {
           if(!openscreenident) {
            handleOpenscreen();
            }
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [newscreenshots]);

   // Check id User is online
   const paratoken = "&token="+token

   // Modal Screens
   const handleOpenscreen = () => {
     setOpenscreenident(true);
   };
 
   const handleClosescreen = () => {
     dispatch(clear_newscreenshot())
     setOpenscreenident(false);
   };

   const deletscreenshot = (Id:any) => {
    const deletescreenshotpayload ={
        Id: Id,
    }  
    dispatch({ type: 'SIGNALR_DELETE_SCREENSHOT', payload: deletescreenshotpayload  });
    handleClosescreen()
}

 let screendata:any
 let screentaken
 let screentakenid: number



 screendata = screenshots.filter((obj: { userParticipantId: any }) => {
       return obj.userParticipantId === newscreenshotsuid 
 });


 if (screendata.length >= 1 ) {
       const lastscreentaken = screendata.slice(-1)[0];
       screentaken = lastscreentaken.imageSrc+paratoken
       screentakenid = lastscreentaken.id
 }

 /*console.log("-------------------")
 console.log(screendata.userParticipantId)
 console.log("ScreendataID: ",newscreenshotsuid)
 console.log("Screendata: ",screendata)
 console.log("Props: ",props.meetingParticipantId)
 console.log("-------------------")*/

 return ( 
   <>
   {newscreenshots && screentaken !== undefined &&

   <Modal
       title={intl.get('IDENTSHOWSCREEN_MODAL_HEAD')}
       opened={openscreenident}
       onClose={handleClosescreen}
       closeOnClickOutside={false}
       withCloseButton={false}
       size="calc(80vw - 5rem)"
       shadow="sm"
       centered
       >
        <>
        <AspectRatio ratio={16 / 8} sx={{ maxWidth: 1920, maxHeight: screenHeight - 50 }} mx="auto">
         {newscreenshots}
         <Image  src={screentaken} />
        </AspectRatio>
         <hr />
         
         
         <Grid>
         <Grid.Col span={6}>
         <Button fullWidth color="green" variant="light" onClick={() => handleClosescreen()}>{intl.get('SCREEN_MODAL_OK')} <Check /></Button>
         </Grid.Col>  
         <Grid.Col span={6}>
         <Button fullWidth color="red" variant="light" onClick={() => deletscreenshot(screentakenid)}> {intl.get('SCREEN_MODAL_NO')} <Trash /></Button>  
         </Grid.Col>
         </Grid>
         </>
   </Modal>
  }

   </>
 );
}

export default ModalTakeScreen;